import { IS_CLIENT } from "@/common/api";
import { SOFT } from "@/common/url";
import { OpenType, startDownloadApp } from "@q/softCore";
import React, { useEffect, useRef } from "react";
import { IAds } from "@/common/interface";
import { getOpenHandler } from "@/utils/appInstall";

interface IProps {
  softId?: number;
  dataText?: string; // 打点文案
  openType?: OpenType;
  href?: string;
  exec?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  ads?: IAds;
  type?: "button";
  callback?: () => void;
  position?: string;
  category?: string;
}

const Link = (props: IProps) => {
  const myRef = useRef<HTMLAnchorElement>(null);
  const {
    type,
    href = "",
    softId = 0,
    dataText = "",
    className = "",
    style = {},
    exec,
    ads,
    openType = OpenType.openDetailInHome,
    callback,
    position,
    category,
  } = props;

  const softUrl = `${SOFT}?id=${softId}`;

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    if (ads && ads.clktk) {
      ads.clktk.forEach((url) => {
        monitor.sendLog(url);
      });
    }
    const validOpenType = Object.values(OpenType).includes(openType)
      ? openType
      : OpenType.openDetailInHome;
    const openHandler = getOpenHandler(validOpenType);

    if (
      exec &&
      (validOpenType === OpenType.execCmdWithClient ||
        validOpenType === OpenType.openAppWithCmd)
    ) {
      (openHandler as (input: string) => any)(exec);
    } else if (
      href &&
      (validOpenType === OpenType.openWithBrowser ||
        validOpenType === OpenType.openWithClient)
    ) {
      (openHandler as (input: string) => any)(href);
    } else if (validOpenType === OpenType.download) {
      startDownloadApp(softId);
    } else if (IS_CLIENT) {
      (
        openHandler as (
          input?: number,
          t?: string,
          p?: string,
          s?: string,
        ) => any
      )(softId, "", position, category);
    } else {
      window.top!.location.href = `${softUrl}`;
    }
    callback && callback();
  };

  useEffect(() => {
    if (type === "button" || !ads) {
      // 按钮类型无需曝光打点
      return;
    }
    const options = {
      root: null,
      threshold: 0.5,
    };

    const observe = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      ads.imptk.forEach((url) => {
        monitor.sendLog(url);
      });
      observer.disconnect();
    }, options);
    const target = myRef.current as HTMLElement;
    observe.observe(target);

    return () => {
      observe.disconnect();
    };
  }, [ads, type]);

  return (
    <a
      ref={myRef}
      className={className}
      onClick={onClick}
      style={style}
      data-text={dataText}
    >
      {props.children}
    </a>
  );
};

export default Link;
